import React from 'react';
import { Helmet } from 'react-helmet';

const PageTitle = ({ title, description, url, keywords }) => {
  // Structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Shree Mangalam School",
    "url": `https://shreemangalamschool.com/${url}`,
    "author": {
      "@type": "Organization",
      "name": "Shree Mangalam School"
    },
    "logo": "https://shreemangalamschool.com/logo192.png",  
    "description": description,
    "publisher": {
      "@type": "Organization",
      "name": "Shree Mangalam School",
      "logo": {
        "@type": "ImageObject",
        "url": "https://shreemangalamschool.com/logo192.png"
      }
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Jaipur-Gudha State Highway (Just on by pass) in Gudha Gorji",
      "addressLocality": "Jhunjhunu",
      "addressRegion": "Rajasthan",
      "postalCode": "333022",
      "addressCountry": "India"
    },
    "telephone": "+91-9928263305",  
    "sameAs": [ 
       "https://whatsapp.com/channel/0029Vb9t3Ks545ulxNoHQY37",
       "https://www.instagram.com/shree_mangalam_academy/?igsh=MWVoZ3lrYWpnM3M2MQ%3D%3D#",
       "https://www.facebook.com/SHREEMangalamAcademy"
    ]
  };

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} /> 
      <link rel="canonical" href={`https://shreemangalamschool.com/${url}`} />

      {/* Open Graph Meta Tags for Social Sharing */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`https://shreemangalamschool.com/${url}`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://shreemangalamschool.com/logo192.png" /> 
      <meta property="og:site_name" content="Shree Mangalam School" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default PageTitle;
